import axios from 'axios'

export function getTraceData(params) {
  return axios.post('https://api-zhuisu.yuncaishang.com/mobileh5/suyuan/get-data', params)
}
